module.exports = "../../../../platform/assets/pageMainIcon/industry_yewushezhilei2.svg";